export default {
  resetZoom: 'Zoom zurücksetzen',
  exitFullscreen: 'Vollbildmodus beenden',
  fullscreen: 'Vollbild',
  showPoints: 'Punkte anzeigen',
  showNotes: 'Notizen anzeigen',
  showExpertView: 'Expertenansicht',
  leaveNote: 'Eine Notiz hinterlassen (Alt + Klick)',
  zoomMode: 'Zoommodus',
  overFlowMenu: 'Weitere Funktionen',
  markersMode: 'Markierungsmodus',
};
